import type { Scene, SceneFolder } from "../types";

export type SceneDropPlacement = "before" | "after";

export function sceneSortOrders(scenes: Pick<Scene, "id" | "campaignId">[]) {
  const nextByCampaign = new Map<string, number>(); const orderById = new Map<string, number>();
  for (const scene of scenes) {
    const order = nextByCampaign.get(scene.campaignId) ?? 0;
    orderById.set(scene.id, order); nextByCampaign.set(scene.campaignId, order + 1);
  }
  return orderById;
}

export function reorderCampaignScenes(scenes: Scene[], campaignId: string, sourceId: string, targetId: string, placement: SceneDropPlacement) {
  if (sourceId === targetId) return scenes;
  const campaignScenes = scenes.filter((scene) => scene.campaignId === campaignId);
  const source = campaignScenes.find((scene) => scene.id === sourceId);
  const target = campaignScenes.find((scene) => scene.id === targetId);
  if (!source || !target) return scenes;

  const withoutSource = campaignScenes.filter((scene) => scene.id !== sourceId);
  const targetIndex = withoutSource.findIndex((scene) => scene.id === targetId);
  const insertionIndex = targetIndex + (placement === "after" ? 1 : 0);
  const folderChanged = source.folderId !== target.folderId;
  const movedSource = folderChanged ? { ...source, folderId: target.folderId } : source;
  const reordered = [...withoutSource.slice(0, insertionIndex), movedSource, ...withoutSource.slice(insertionIndex)];
  if (!folderChanged && reordered.every((scene, index) => scene.id === campaignScenes[index]?.id)) return scenes;

  let campaignIndex = 0;
  return scenes.map((scene) => scene.campaignId === campaignId ? reordered[campaignIndex++] : scene);
}

export function moveSceneToFolder(scenes: Scene[], campaignId: string, sourceId: string, folderId?: string) {
  const campaignScenes = scenes.filter((scene) => scene.campaignId === campaignId);
  const source = campaignScenes.find((scene) => scene.id === sourceId);
  if (!source || source.folderId === folderId) return scenes;

  const movedSource = { ...source, folderId };
  const withoutSource = campaignScenes.filter((scene) => scene.id !== sourceId);
  let insertionIndex = -1;
  for (let index = 0; index < withoutSource.length; index += 1) if (withoutSource[index].folderId === folderId) insertionIndex = index;
  const reordered = insertionIndex < 0
    ? [...withoutSource, movedSource]
    : [...withoutSource.slice(0, insertionIndex + 1), movedSource, ...withoutSource.slice(insertionIndex + 1)];

  let campaignIndex = 0;
  return scenes.map((scene) => scene.campaignId === campaignId ? reordered[campaignIndex++] : scene);
}

export function reorderCampaignSceneFolders(folders: SceneFolder[], campaignId: string, sourceId: string, targetId: string, placement: SceneDropPlacement) {
  if (sourceId === targetId) return folders;
  const campaignFolders = folders.filter((folder) => folder.campaignId === campaignId);
  const source = campaignFolders.find((folder) => folder.id === sourceId);
  const target = campaignFolders.find((folder) => folder.id === targetId);
  if (!source || !target) return folders;

  const withoutSource = campaignFolders.filter((folder) => folder.id !== sourceId);
  const targetIndex = withoutSource.findIndex((folder) => folder.id === targetId);
  const insertionIndex = targetIndex + (placement === "after" ? 1 : 0);
  const reordered = [...withoutSource.slice(0, insertionIndex), source, ...withoutSource.slice(insertionIndex)];
  if (reordered.every((folder, index) => folder.id === campaignFolders[index]?.id)) return folders;

  let campaignIndex = 0;
  return folders.map((folder) => folder.campaignId === campaignId ? reordered[campaignIndex++] : folder);
}
